import "./ArchiveModal.scss";

import Button from "components/Button/Button";
import Card from "components/Card/Card";

import KaboodleModal from "./KaboodleModal";

interface ArchiveFileModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ArchiveFileModal = ({
  isOpen,
  onClose,
  onConfirm,
}: ArchiveFileModalProps) => {
  return (
    <KaboodleModal
      isOpen={isOpen}
      onClose={onClose}
      footer={
        <div className="flex jc-c">
          <Button className="delete" onClick={onConfirm}>
            Confirm Archive
          </Button>
          <Button onClick={onClose}>Cancel</Button>
        </div>
      }
    >
      <Card heading="Delete Row">
        <p>Are you sure you want to archive this file?</p>
      </Card>
    </KaboodleModal>
  );
};

export default ArchiveFileModal;
